var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 161,
    viewBox: "0 0 249 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.14 136H13.778C7.32274 136 3.01925 130.58 4.19293 123.855L23.0696 12.1447C24.2433 5.41993 30.4051 0 36.8603 0H239.222C245.677 0 249.981 5.41993 248.807 12.1447L229.93 123.855C228.757 130.58 222.595 136 216.14 136Z",
    fill: "#BDCCD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5013 160.4C44.2013 160.4 40.8013 156.9 40.8013 152.7V135.7H56.3013V152.7C56.3013 156.9 52.8013 160.4 48.5013 160.4Z",
    fill: "#BDCCD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.701 160.4C180.401 160.4 177.001 156.9 177.001 152.7V135.7H192.501V152.7C192.401 156.9 188.901 160.4 184.701 160.4Z",
    fill: "#BDCCD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1013 46.3L74.5013 89.4H5.80127L13.0013 46.3H82.1013Z",
    fill: "#427169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.801 46.3L154.201 89.4H78.6011L86.2011 46.3H161.801Z",
    fill: "#427169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.401 89.4H158.401L166.001 46.3H234.601L235.301 42.1H166.701L174.101 0H169.901L162.501 42.1H86.9011L94.3011 0H90.1011L82.8011 42.1H13.7011L13.0011 46.3H82.0011L74.4011 89.4H5.80107L5.10107 93.6H73.7011L66.3011 135.7H70.5011L77.9011 93.6H153.501L146.101 135.7H150.301L157.701 93.6H226.801L227.401 89.4ZM78.6011 89.4L86.2011 46.3H161.801L154.201 89.4H78.6011Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.701 123.5C220.601 130.2 214.501 135.6 208.201 135.6H150.201L157.601 93.5H226.701L221.701 123.5Z",
    fill: "#427169"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.401 89.4H158.401L166.001 46.3H234.601L227.401 89.4Z",
    fill: "#427169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.301 42.1H166.701L174.101 0H230.801C237.101 0 241.401 5.40001 240.301 12.1L235.301 42.1Z",
    fill: "#427169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.001 0L162.501 42.1H86.9011L94.4011 0H170.001Z",
    fill: "#427169"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2012 0L82.8012 42.1H13.7012L18.7012 12.1C19.8012 5.40001 25.9012 0 32.2012 0H90.2012Z",
    fill: "#427169"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.501 93.5L146.101 135.6H70.5012L77.9012 93.5H153.501Z",
    fill: "#427169"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7012 93.5L66.3012 135.6H9.60117C3.30117 135.6 -0.998838 130.2 0.201162 123.5L5.20116 93.5H73.7012Z",
    fill: "#427169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.db02c31a6a9391fe610376af5b02efa9.svg";
export { ForwardRef as ReactComponent };